export const SENSITIVE_PLACEHOLDER = '[REDACTED]'
